import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ 
  children, 
  requiredRole = null, 
  requiredSite = null,
  fallbackPath = '/login',
  showLoading = true 
}) => {
  const { loading, isAuthenticated, hasRole, hasSiteAccess, user } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return showLoading ? <LoadingSpinner /> : <div style={{ display: 'none' }} />;
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Si se requiere un rol específico, verificar que el usuario esté completamente cargado
  if (requiredRole) {
    // Si el usuario no está cargado aún, mostrar loading
    if (!user) {
      return showLoading ? <LoadingSpinner /> : <div style={{ display: 'none' }} />;
    }
    
    // Si el usuario está cargado pero no tiene el rol requerido
    if (!hasRole(requiredRole)) {
      console.log('ProtectedRoute: Access denied for role:', requiredRole);
      console.log('ProtectedRoute: User object:', user);
      console.log('ProtectedRoute: User roles:', user?.roles);
      return (
        <div className="access-denied">
          <h2>Acceso Denegado</h2>
          <p>No tienes permisos para acceder a esta página.</p>
          <p>Rol requerido: {requiredRole}</p>
          <p>Roles del usuario: {user?.roles ? user.roles.join(', ') : 'No hay roles'}</p>
        </div>
      );
    }
  }

  // Si se requiere acceso a un site específico
  if (requiredSite && !hasSiteAccess(requiredSite)) {
    return (
      <div className="access-denied">
        <h2>Acceso Denegado</h2>
        <p>No tienes acceso a este site.</p>
        <p>Site requerido: {requiredSite}</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
